type DashboardHeaderProps = {
  userName?: string;
};

const getFirstName = (fullName?: string) => {
  const normalizedName = fullName?.trim();

  if (!normalizedName) {
    return "Utilisateur";
  }

  return normalizedName.split(/\s+/)[0];
};

export const DashboardHeader = ({ userName }: DashboardHeaderProps) => {
  const firstName = getFirstName(userName);

  return (
    <header>
      <h1
        className={[
          "font-bold tracking-tight text-indigo-950",
          "text-2xl sm:text-[26px] lg:text-[28px]",
        ].join(" ")}
      >
        Bienvenue, {firstName}
      </h1>

      <p className="mt-1.5 text-[13px] leading-5 text-slate-600 sm:text-sm">
        Créez, gérez et valorisez vos documents professionnels.
      </p>
    </header>
  );
};
